module.exports = __webpack_public_path__ + "img/3.3b23f0d7.jpg";